import { FontFamily } from 'fonts'

// this is an object, because initially this hook received a list of font
// families to load and it's easier to go back to that like this
export const GoogleFontStyleStrings: { [fontFamily in FontFamily]?: string | null } = {
  Alegreya: 'Alegreya:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900',
  'Alegreya Sans':
    'Alegreya Sans:ital,wght@0,100;0,300;0,400;0,500;0,700;0,800;0,900;1,100;1,300;1,400;1,500;1,700;1,800;1,900',
  Aleo: 'Aleo:ital,wght@0,400;0,700;1,400;1,700',
  'Andada Pro': 'Andada Pro:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800',
  Anton: 'Anton',
  Archivo:
    'Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Archivo Narrow': 'Archivo Narrow:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700',
  Arvo: 'Arvo:ital,wght@0,400;0,700;1,400;1,700',
  Barlow:
    'Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  BioRhyme: 'BioRhyme:wght@200;300;400;700;800',
  Cabin: 'Cabin:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700',
  Cardo: 'Cardo:ital,wght@0,400;0,700;1,400',
  Catamaran: 'Catamaran:wght@100;200;300;400;500;600;700;800;900',
  Caveat: 'Caveat:wght@400;500;600;700',
  Chivo: 'Chivo:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900',
  'Concert One': 'Concert One',
  Cormorant: 'Cormorant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700',
  'Crimson Pro':
    'Crimson Pro:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Dancing Script': 'Dancing Script:wght@400;500;600;700',
  'DM Sans': 'DM Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700',
  Domine: 'Domine:wght@400;500;600;700',
  Dosis: 'Dosis:wght@200;300;400;500;600;700;800',
  'EB Garamond': 'EB Garamond:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800',
  Eczar: 'Eczar:wght@400;500;600;700;800',
  'Encode Sans': 'Encode Sans:wght@100;200;300;400;500;600;700;800;900',
  Enriqueta: 'Enriqueta:wght@400;500;600;700',
  Epilogue:
    'Epilogue:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Fira Sans':
    'Fira Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  Hahmlet: 'Hahmlet:wght@100;200;300;400;500;600;700;800;900',
  'IBM Plex Mono':
    'IBM Plex Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700',
  'IBM Plex Sans':
    'IBM Plex Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700',
  'IBM Plex Serif':
    'IBM Plex Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700',
  Inconsolata: 'Inconsolata:wght@200;300;400;500;600;700;800;900',
  'Inknut Antiqua': 'Inknut Antiqua:wght@300;400;500;600;700;800;900',
  'Inria Serif': 'Inria Serif:wght@300;400;700',
  Inter: 'Inter:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700',
  'JetBrains Mono':
    'JetBrains Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800',
  'Josefin Sans':
    'Josefin Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700',
  Jost: 'Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  Karla: 'Karla:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800',
  Lato: 'Lato:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Libre Baskerville': 'Libre Baskerville:ital,wght@0,400;0,700;1,400',
  'Libre Franklin':
    'Libre Franklin:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Lobster Two': 'Lobster Two:ital,wght@0,400;0,700;1,400;1,700',
  Lora: 'Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700',
  Manrope: 'Manrope:wght@200;300;400;500;600;700;800',
  'Maven Pro': 'Maven Pro:wght@400;500;600;700;800;900',
  Merriweather: 'Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900',
  Montserrat:
    'Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  Mukta: 'Mukta:wght@200;300;400;500;600;700;800',
  Neuton: 'Neuton:ital,wght@0,200;0,300;0,400;0,700;0,800;1,400',
  Newsreader:
    'Newsreader:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800',
  'Noto Sans': 'Noto Sans:ital,wght@0,400;0,700;1,400;1,700',
  Nunito:
    'Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Nunito Sans':
    'Nunito Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900',
  'Old Standard TT': 'Old Standard TT:ital,wght@0,400;0,700;1,400',
  'Open Sans': 'Open Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800',
  Oswald: 'Oswald:wght@200;300;400;500;600;700',
  Oxygen: 'Oxygen:wght@300;400;700',
  Pacifico: 'Pacifico',
  'Permanent Marker': 'Permanent Marker',
  Play: 'Play:wght@400;700',
  'Playfair Display':
    'Playfair Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900',
  Prompt:
    'Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Proza Libre': 'Proza Libre:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800',
  Poppins:
    'Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'PT Sans': 'PT Sans:ital,wght@0,400;0,700;1,400;1,700',
  'PT Serif': 'PT Serif:ital,wght@0,400;0,700;1,400;1,700',
  Quicksand: 'Quicksand:wght@300;400;500;600;700',
  Raleway:
    'Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  Recursive: 'Recursive:wght@300;400;500;600;700;800;900',
  Roboto: 'Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
  'Roboto Condensed': 'Roboto Condensed:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700',
  'Roboto Mono':
    'Roboto Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700',
  'Roboto Slab': 'Roboto Slab:wght@100;200;300;400;500;600;700;800;900',
  Rosario: 'Rosario:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700',
  Rosarivo: 'Rosarivo:ital@0;1',
  Rubik: 'Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Saira Condensed': 'Saira Condensed:wght@100;200;300;400;500;600;700;800;900',
  Signika: 'Signika:wght@300;400;500;600;700',
  Sora: 'Sora:wght@100;200;300;400;500;600;700;800',
  'Source Code Pro':
    'Source Code Pro:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
  'Source Sans Pro':
    'Source Sans Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900',
  'Source Serif Pro':
    'Source Serif Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900',
  'Space Grotesk': 'Space Grotesk:wght@300;400;500;600;700',
  'Space Mono': 'Space Mono:ital,wght@0,400;0,700;1,400;1,700',
  Spectral: 'Spectral:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800',
  Syne: 'Syne:wght@400;500;600;700;800',
  'Titillium Web': 'Titillium Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700',
  Ubuntu: 'Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700',
  'Ubuntu Mono': 'Ubuntu Mono:ital,wght@0,400;0,700;1,400;1,700',
  Vollkorn: 'Vollkorn:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900',
  'Work Sans':
    'Work Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
}
